var $ = jQuery.noConflict();
$(document).ready(function() {
  if($('.hero_slider').length == 1){
    $(".hero_slider").slick({
      infinite: true,
      arrows: false,
      dots: false,
      autoplay: false,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
      swipe: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            draggable: true,
            swipe: true,
            dots: true
          }
        }
      ]
    });
  
   //ticking machine
      var percentTime;
      var tick;
      var time = .1;
      var progressBarIndex = 0;
  
      $('.progressBarContainer .progressBar').each(function(index) {
          var progress = "<div class='inProgress inProgress" + index + "'></div>";
          $(this).html(progress);
      });
  
      function startProgressbar() {
          resetProgressbar();
          percentTime = 0;
          tick = setInterval(interval, 10);
      }
  
      function interval() {
        var progressBarIndex = $('.hero_slider .slick-current').attr("data-slick-index");
        percentTime += 1 / (time + 5);
        $('.inProgress' + progressBarIndex).css({
            width: percentTime + "%"
        });
        if (percentTime >= 100) {
            $('.single-item').slick('slickNext');
            progressBarIndex++;
            if (progressBarIndex > 2) {
                progressBarIndex = 0;
            }
            startProgressbar();
        }
      }
  
      function resetProgressbar() {
          $('.inProgress').css({
              width: 0 + '%'
          });
          clearInterval(tick);
      }
      startProgressbar();
      // End ticking machine
  
      $('.progressBarContainer .item').on('click',function () {
      	clearInterval(tick);
      	var goToThisIndex = $(this).find("span").data("slickIndex");
      	$('.single-item').slick('slickGoTo', goToThisIndex, false);
      	startProgressbar();
      }); 
  }
  if($('.attachments-slider-inner').length == 1){
  $('.attachments-slider-inner').slick({
       dots: false,
       infinite: false,
       arrows: true,
       loop:false,
       speed: 400,
       slidesToShow: 6,
       centerMode: false,
       variableWidth: false,
       slidesToScroll: 1,
       prevArrow:"<button type='button' class='slick-prev pull-left'><img src='//cdn.shopify.com/s/files/1/0433/3282/9343/files/slider-arrow.png' alt='slider arrows'></button>",
       nextArrow:"<button type='button' class='slick-next pull-right'><img src='//cdn.shopify.com/s/files/1/0433/3282/9343/files/slider-arrow.png' alt='slider arrows'></button>",
        responsive: [
          {
            breakpoint: 1550,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
     });
  }


  if($('.product-loop-slider-inner').length == 1){
    $('.product-loop-slider-inner').slick({
         dots: false,
         infinite: false,
         arrows: true,
         loop:false,
         speed: 400,
         slidesToShow: 5,
         centerMode: false,
         variableWidth: false,
         slidesToScroll: 1,
         prevArrow:"<button type='button' class='slick-prev pull-left'><img src='//cdn.shopify.com/s/files/1/0560/8770/7708/files/right-arrows.png' alt='slider arrows'></button>",
         nextArrow:"<button type='button' class='slick-next pull-right'><img src='//cdn.shopify.com/s/files/1/0560/8770/7708/files/right-arrows.png' alt='slider arrows'></button>",
          responsive: [
            {
              breakpoint: 1550,
              settings: {
                slidesToShow: 5
              }
            },
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
       });
    }
});  